export default __webpack_public_path__ + "static/media/hht2_ep20_timeline_q02_b.71e588e3.png";